import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function NetIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M12.278 6.2c0 2.32-1.915 4.2-4.278 4.2m4.278-4.2C12.278 3.88 10.363 2 8 2m4.278 4.2H3.722M8 10.4c-2.363 0-4.278-1.88-4.278-4.2M8 10.4a6.36 6.36 0 0 0 1.712-4.2A6.36 6.36 0 0 0 8 2m0 8.4a6.36 6.36 0 0 1-1.71-4.2A6.36 6.36 0 0 1 8 2m0 8.4v1.2M3.722 6.2C3.722 3.88 5.637 2 8 2m1.222 10.8c0 .663-.547 1.2-1.222 1.2a1.21 1.21 0 0 1-1.222-1.2m2.444 0c0-.663-.547-1.2-1.222-1.2m1.222 1.2H13.5m-6.722 0c0-.663.547-1.2 1.222-1.2m-1.222 1.2H2.5" /></svg>
  );
}

export default NetIcon;
